import { alpha } from '@mui/material';

export const getDialogPaperStyle = (isMobile) => ({
    borderRadius: isMobile ? '16px 16px 0 0' : 5,
    overflow: 'hidden',
    overflowY: 'auto',
    p: 0,
    maxWidth: isMobile ? '100%' : 400,
    width: '100%',
    boxShadow: 24,
    m: isMobile ? 0 : { xs: 1, sm: 3 },
    background: 'background.paper',
    display: 'flex',
    flexDirection: 'column',
    maxHeight: isMobile ? '80vh' : '90vh',
    position: isMobile ? 'fixed' : 'relative',
    bottom: isMobile ? 0 : 'auto',
    left: isMobile ? 0 : 'auto',
    right: isMobile ? 0 : 'auto',
});

export const getHeaderBoxStyle = (theme) => ({
    background: theme.palette.primary.main,
    color: 'white',
    px: { xs: 1.5, sm: 3 },
    py: { xs: 1.5, sm: 2.5 },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    borderBottom: '1px solid rgba(255,255,255,0.08)',
    position: 'relative',
    flexShrink: 0,
});

export const getHeaderTitleStyle = () => ({
    fontWeight: 700, 
    fontSize: '1.35rem', 
    mb: 0.5
});

export const getHeaderSubtitleStyle = () => ({
    fontSize: '0.98rem', 
    opacity: 0.85
});

export const getContentContainerStyle = () => ({
    overflowY: 'auto', 
    flex: 1, 
    minHeight: 0
});

export const getPaperStyle = (theme) => ({
    borderRadius: 0,
    overflow: 'hidden',
    border: `1px solid ${theme.palette.divider}`,
    [theme.breakpoints.down('md')]: {
        borderRadius: 3,
    }
});

export const getSectionBoxStyle = (theme) => ({
    p: 3,
    borderBottom: `1px solid ${theme.palette.divider}`,
    [theme.breakpoints.down('md')]: {
        p: 2,
    }
});

export const getBottomSectionBoxStyle = (theme) => ({
    p: 3,
    [theme.breakpoints.down('md')]: {
        p: 2,
    }
});

export const getTypographyStyle = () => ({
    fontWeight: 500
});

export const getDialogActionsStyle = (theme, isMobile) => ({
    p: 2.5,
    bgcolor: theme.palette.mode === 'dark'
        ? alpha(theme.palette.background.paper, 0.5)
        : alpha(theme.palette.grey[50], 0.5),
    borderTop: `1px solid ${theme.palette.divider}`,
    pb: isMobile ? 'calc(env(safe-area-inset-bottom) + 20px)' : 2.5
});

export const getActionButtonsContainerStyle = (isMobile) => ({
    width: '100%',
    display: 'flex',
    flexDirection: isMobile ? 'column' : 'row',
    gap: isMobile ? 1.5 : 1,
    justifyContent: 'flex-end'
});

export const getCancelButtonStyle = (theme, isMobile) => ({
    color: theme.palette.text.secondary,
    order: isMobile ? 2 : 1
});

export const getProceedButtonStyle = (theme, isMobile) => ({
    borderRadius: 1.5,
    px: 2,
    bgcolor: theme.palette.success.main,
    '&:hover': {
        bgcolor: theme.palette.success.dark
    },
    order: isMobile ? 1 : 2
});
